<script>
    import { Alert,Card,CardHeader,CardBody,Label,Input,Button} from 'sveltestrap'
    import {doLogin} from './LoginFunc.svelte';
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    let credentials={login:"",password:""};
    let msg="";
    let interval = setTimeout(()=>{msg=undefined},3000)
    function showMsg(mesg){
        clearInterval(interval)
        msg=mesg
        setTimeout(()=>{msg=undefined},3000)
    }
    
    function invokeLogin(x){
        console.log('login result',JSON.stringify(x))
         if(x.result){
                dispatch('loggedOn', { user:x.user });
            }else{
                showMsg("ошибка авторизации")
            }
    }

</script>
<div style="width:400px;">
    <Card>
        <CardHeader>Вход с учетной записью Telescript</CardHeader>
        <CardBody>
            <Input type="text" placeholder="Login" bind:value={credentials.login} id="login-input"/>
            <Input type="password" placeholder="Password" bind:value={credentials.password} id="password-input" />
            <Button block outline color="secondary" on:click={()=>{doLogin((r)=>invokeLogin(r),credentials.login,credentials.password)}}>Вход</Button>
            {#if msg}
                <Alert color="danger">{msg}</Alert>
            {/if}
        </CardBody>
    </Card>
</div>